import { render, staticRenderFns } from "./ModalSuporteAlterarSituacaoSolicitacao.vue?vue&type=template&id=00a29097&scoped=true"
import script from "./ModalSuporteAlterarSituacaoSolicitacao.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteAlterarSituacaoSolicitacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteAlterarSituacaoSolicitacao.vue?vue&type=style&index=0&id=00a29097&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a29097",
  null
  
)

export default component.exports